/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeaturesConfigModule } from '@spartacus/core';
import { ProductImageZoomThumbnailsComponent } from '@spartacus/product/image-zoom/components';
import { CarouselModule, MediaModule } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-image-zoom-thumbnails',
  templateUrl: './product-image-zoom-thumbnails.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MediaModule, CarouselModule, CommonModule, FeaturesConfigModule],
})
export class CustomProductImageZoomThumbnailsComponent extends ProductImageZoomThumbnailsComponent {}
